import { bindActionCreators, } from 'redux'
import { connect, } from 'react-redux'

import {
  navViewListEventInfo,
  navViewTripAsList,
} from 'redux/actions'
import {
  selectedTripId,
  selectedTripData,
  selectedEventData,
  selectedEventNextEventId,
  selectedEventNextEvent,
  selectedEventPreviousEventId,
  selectedEventPreviousEvent,
  selectedEventInfoDisplayed,
  currentEventId,
} from 'redux/reducers'
import Component from './component'

const mapStateToProps = state => ({
  tripId: selectedTripId(state),
  tripData: selectedTripData(state),
  selectedEventData: selectedEventData(state),
  selectedEventNextEventId: selectedEventNextEventId(state),
  selectedEventNextEvent: selectedEventNextEvent(state),
  selectedEventPreviousEventId: selectedEventPreviousEventId(state),
  selectedEventPreviousEvent: selectedEventPreviousEvent(state),
  selectedEventInfoDisplayed: selectedEventInfoDisplayed(state),
  currentEventId: currentEventId(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      navViewListEventInfo,
      navViewTripAsList,
    },
    dispatch
  ),
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)



// WEBPACK FOOTER //
// ./src/components/_sceneManager/Scenes/TripListingScene/index.js